// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"befc3848","289":"6d8b7e3d","458":"8216c585"}[chunkId] + ".chunk.js";
};